// extracted by mini-css-extract-plugin
export default {"violetButton":"VioletButton_violetButton__8trfo"};